import { AdvancedTreeObject } from 'common/type';
import React, { FC } from 'react';

type Props = {
  onChangeSelectedGroup: (indice) => void;
  object: AdvancedTreeObject;
  onClickAddButton: (indice) => void;
};

const AdvancedTreeItem: FC<Props> = ({
  onChangeSelectedGroup,
  object,
  onClickAddButton,
  children
}) => {
  return (
    <div
      className={`advtree-item ${object.isChecked ? 'checked' : ''} ${
        object.itemSelected ? 'done' : ''
      }`}
      key={object.index}
    >
      <div
        className="advtree-header "
        onClick={event => onChangeSelectedGroup(object.index)}
      >
        <div className="advtree-title ">
          <span className="id hint module-color top-left">
            <div className="hint-content">
              {object.id} -
              {object.itemSelected ? object.itemSelected : object.titleDefault}
            </div>
          </span>
          <span className="title">
            {object.itemSelected ? object.itemSelected : object.titleDefault}
          </span>
          <span className="ellipsis">...</span>
        </div>
        <div className="advtree-actions">
          {!object.isEditing && (
            <button
              className="btn circle"
              onClick={_ => onClickAddButton(object.index)}
            >
              <em className="fa fa-plus" />
              <div className="btn-actions-label">Adicionar</div>
            </button>
          )}
        </div>
      </div>
      <div className="advtree-content">{children}</div>
    </div>
  );
};

export { AdvancedTreeItem };
